module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    staticClass: "product-list"
  }, [(_vm.suggest) ? _c('div', {
    staticClass: "suggest"
  }, [_c('p', [_vm._v("没找到\"" + _vm._s(_vm.keys) + "\"的搜索结果\"")]), _vm._v(" "), _c('p', [_vm._v("为你推荐\"" + _vm._s(_vm.suggest.keyword) + "\"的相关商品")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return (_vm.data.length) ? _c('simple-product', {
      class: {
        'no-margin': (index + 1) % 2 === 0
      },
      attrs: {
        "sdk": _vm.sdk,
        "env": _vm.env,
        "index": index,
        "searchKey": _vm.keys,
        "data": item
      },
      on: {
        "click": function($event) {
          return _vm.trackData(index)
        }
      }
    }) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7c0662"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/search/components/list.vue
// module id = 208
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 15 16 17 19 23 27 28 30 36 39 40 44 45